var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainLifequalityW150(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 37.5,
    y: 37.5,
    width: 75,
    height: 75,
    viewBox: "0 0 1346.6667 1346.6667",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.704 1046.5h2927.2v-830.87h-2927.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1578.4 371.95h2898v-588.95h-2898z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m742.89 632.43h367.11v-178.33h-367.11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m565.3 378.4h2786.8v-223.8h-2786.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m505 1010c-278.9 0-505-226.1-505-505s226.1-505 505-505 505 226.1 505 505-226.1 505-505 505z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.5 323h2823.3v-589.1h-2823.3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m543.5 80.9h529.2v-41.4h-529.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m985.3 235.2h329.8v-19.9h-329.8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m613.1 235.2h329.9v-19.9h-329.9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 1346.7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3442.7,638.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2 5.3-4.4 12.2-7.3 20.4-47.9 135.1-193.8 546.4-517.6 546.4h-64.1v-17.6h-7059.7v-1405h4861.7l160.8-52.8h1055.9l160.8 52.8h1470.3l5.8 57.8c0.7 7.3 17.9 181.9 17.9 355.7 0.1 125.9-50.4 351.6-84.5 442.3",
    fill: "#82cde6"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    opacity: 0.53999
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1193.7,944.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-100.9-2.8-181.1-84.2-183.5-183.9-24.9 102.1-118.2 176.5-227.4 173.5-116.7-3.2-210.3-93.6-220.5-207.1-6.6 1.4-13.3 2.4-20.2 3.1-14.1 121.2-118.6 213.6-242.9 210.2-131.4-3.6-235.1-113.1-231.4-244.5 2.7-98.5 64.9-181.4 151.1-215.2-77-28.9-130.9-104.1-128.5-190.9 0.7-26.2 6.6-51.1 16.5-73.7h362.9c11.3 25.9 17.4 54.5 16.6 84.6-0.1 5.3-0.6 10.5-1.1 15.7 13.1-2.2 26.7-3.2 40.5-2.8 101.6 2.8 184.2 77.6 200.4 174.2 21.9-6.3 45.1-9.4 69.1-8.7 57.8 1.6 109.9 24.6 149.1 61.2 22.6-26.2 56.2-42.3 93.5-41.3 49.4 1.4 91 32.7 107.8 76 18.5-5.4 38.1-8.1 58.4-7.6 104.2 2.9 186.3 89.6 183.5 193.8-2.9 104.2-89.7 186.3-193.9 183.4",
    fill: "#f1f1f1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3526.9 149.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-23.8 250.2h-5067.8v-616.7h5068.3l23.1 356.9v1.3c0.1 2.8 0.1 5.5 0.2 8.3",
    fill: "#03879d"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    opacity: 0.21001
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(568.9,-205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-98.6 55.3-506.9-7.8-602.6 56.3-95.7 64 1287-24.3 1346.6 61.4 56.1 80.7-235.4 78.6-979.5 79.4-1100.5 1.2-2095 140.2 296.2 145.2 774.4 1.6 873.1 155 364.5 204.4-700.3 68-2572.5 0.1-2572.5 0.1l205.6-558.8h1953.9c-0.7 3.8-4.5 7.8-12.2 12",
    fill: "#068172"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(753.2,838.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-39.8-6.8-78.7-33.8-112.6-58.9-100-73.9-205.8-146.5-316-204-37.3-19.5-96.5-40.7-137.1-29.5-42.4 11.6-92 67.3-138.2 68.9-39.5 1.3-63.2-29.8-97.1-50.1-175.8-105.1-263.6-94.2-439.4-199.3l1100.3 6.4c33.4 63.8 66.2 64.3 67.5 72.6 1.7 11 139.3 81.7 81.5 219.5-33.3 79.4-23.3 138.5-8.9 174.4",
    fill: "#8b909a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(861.3,794.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-17.7 16.3-36.3 32.7-59.1 40.4-16.3 5.5-32.7 6-49 3.3-14.4-35.9-24.4-95.1 8.9-174.4 57.8-137.8-79.8-208.6-81.5-219.5-1.3-8.2-41.8-25.9-75.2-89.7l461.9 34.6 211.4 2.4c-62.7 79.5-343 334.2-417.4 402.9",
    fill: "#afaeb8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-470,564.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-47 1.5-92.2-16.8-135.7-34.8-145.2-60-290.3-120-435.5-180l1232.8-109.8c-173.1 91.7-346.2 183.3-519.2 275-44.8 23.7-91.7 48-142.4 49.6",
    fill: "#757a83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(837.6,632.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-26.5 0.6-207.4-4.7-272.3-178.3h544.6c-64.9 173.6-245.8 178.9-272.3 178.3",
    fill: "#76982c"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(837.6,632.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s139.6-31.6 89.6-102.1c-40.4-56.9-242.4-64.6-168-76.2h350.8c-65 173.6-245.9 178.9-272.4 178.3",
    fill: "#068172"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(559.3,454.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.2 0-14.3-2.6-19.7-7.4l-47.4-41 42.1-36.3h2662.5c7.5 0 27.7-0.9 54.6-2.4 94.1 16.6 244.5 71.1 241.9 85.8-0.1 0.4-0.2 0.9-0.3 1.3z",
    fill: "#eede4c"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2923.5,378.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-1163.5l3.3-6h-1198c62.7-120.9 233.9-128.5 269.1-128.5h6.2c32.6 0 182.2 6.5 253.8 103.8 51.8-30 124.1-32.2 144.5-32.2h4.5c14.4 0 55.1 1.1 96 12.5 4.6 1.3 9.1 2.7 13.6 4.2 6.8 2.3 13.5 4.9 20 7.9 7.3 3.3 14.3 7.1 20.9 11.4 66.1-48.2 172-51.5 200.2-51.5h9c2.4 0 5.3 0.1 8.4 0.2 1.6 0 3.3 0.1 5 0.2 5.3 0.2 11.3 0.5 17.8 1 6.6 0.5 13.7 1.1 21.3 2 20.2 2.3 43.3 6.2 66.6 12.6 17.4 4.8 34.9 11.1 51.1 19.3 3.3 1.6 6.5 3.4 9.6 5.2 123.4-174.3 388.6-185.9 446.1-185.9h10.9c19.7 0 63.9 1.4 118.5 10.2 5.5 0.9 11.1 1.9 16.8 2.9 8.5 1.6 17.2 3.3 26.1 5.3s17.9 4.1 27.1 6.5c12.2 3.2 24.6 6.8 37 10.8 6.2 2 12.5 4.2 18.7 6.4 6.2 2.3 12.5 4.6 18.7 7.1 44.4 17.8 88.3 42 126.5 74.7 116.1-60.4 253.6-65.4 296.1-65.4h10.8c59.1 0 302.9 9.7 415.9 165.3h-413.9z",
    fill: "#1a7769"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    opacity: 0.57001
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    opacity: 0.64999
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(808.1,80.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-146.1 0-264.6-4.4-264.6-19.4s118.4-22 264.6-22 264.6 7 264.6 22-118.5 19.4-264.6 19.4",
    fill: "#016357"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    opacity: 0.64999
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(985.3,225.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-7.2 56.9-10.6 127.1-10.6s202.7 3.4 202.7 10.6-132.5 9.3-202.7 9.3-127.1-2.1-127.1-9.3",
    fill: "#016357"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    opacity: 0.64999
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(613.1,225.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-7.2 56.9-10.6 127.1-10.6s202.8 3.4 202.8 10.6-132.6 9.3-202.7 9.3-127.2-2.1-127.2-9.3",
    fill: "#016357"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(943,291.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-46.8 0-84.7-1.6-84.7-7.2s37.9-8.2 84.7-8.2 84.7 2.6 84.7 8.2-38 7.2-84.7 7.2",
    fill: "#f1f1f1"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1676.4,396.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-488.3l81.9 18.2h-1316l-17.4-22.9-17.9-22.8h2059.3l-378.4 12.4z",
    fill: "#76982c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(834.9,454.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.1 100.8-22.6-131.1h55.9l-11.3 74.1z",
    fill: "#016357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(842,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h44.3l-22.8 114.6z",
    fill: "#068172"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(876.1,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h36.8l-19 178.6z",
    fill: "#016357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(946.6,445.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-9.5 73-16.3-95h40.5l-8.3 53.7z",
    fill: "#068172"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.7,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32.2l-16.5 152z",
    fill: "#068172"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(976.5,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h26.7l-13.8 83z",
    fill: "#068172"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014.5,438.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.5 50.2-11.3-65.3h27.9l-5.7 36.9z",
    fill: "#016357"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(765.7,438.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.5 50.2-11.3-65.3h27.9l-5.7 36.9z",
    fill: "#76982c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(769.2,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h22.1l-11.3 104.5z",
    fill: "#a2c02e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(786.3,423.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18.3l-9.5 57.1z",
    fill: "#76982c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.4,254.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.7 0 1.3-0.1 2-0.1 1.4 30 11.2 58.9 28.4 83.5-0.5 0.4-1.1 0.8-1.6 1.2-17.4-25-27.4-54.3-28.8-84.6",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79,348.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.8-4.1-9.6-8.7-8.5-10.3s6.8 0.3 12.6 4.4 9.6 8.7 8.5 10.3c-1.1 1.7-6.8-0.3-12.6-4.4",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.9,333.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.8-4.1-9.6-8.7-8.5-10.3s6.8 0.3 12.6 4.4 9.6 8.7 8.5 10.3-6.7-0.3-12.6-4.4",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.5,338.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.6-1.1 0.3-6.8 4.4-12.6s8.7-9.6 10.3-8.5-0.3 6.8-4.4 12.6c-4 5.9-8.6 9.6-10.3 8.5",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.8,359.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.6-1.1 0.4-6.8 4.4-12.6 4.1-5.8 8.7-9.6 10.3-8.5s-0.4 6.8-4.4 12.6c-4.1 5.8-8.7 9.6-10.3 8.5",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.8,339.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7 1.2-12.9 0.6-13.3-1.3-0.3-2 5-4.6 12-5.8s12.9-0.6 13.3 1.3c0.4 2-5 4.6-12 5.8",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.5,344.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7 1.2-12.9 0.6-13.3-1.3-0.3-2 5-4.6 12-5.8s12.9-0.6 13.3 1.3c0.4 2-5 4.6-12 5.8",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.8,326.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2-7-0.6-12.9 1.3-13.3 2-0.3 4.6 5 5.8 12s0.6 12.9-1.3 13.3c-2 0.3-4.6-5-5.8-12",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.2,351.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2-7-0.6-12.9 1.3-13.3 2-0.3 4.6 5 5.8 12s0.6 12.9-1.3 13.3-4.6-5-5.8-12",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.3,351.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.8-6-5.5-11.8-3.8-12.8 1.7-1.1 6.1 3 9.9 9s5.5 11.8 3.8 12.8-6.1-3-9.9-9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.6,329.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.8-6-5.5-11.8-3.8-12.8 1.7-1.1 6.1 3 9.9 9s5.5 11.8 3.8 12.8c-1.7 1.1-6.1-3-9.9-9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.4,334.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6 3.8-11.8 5.5-12.8 3.8-1.1-1.7 3-6.1 9-9.9s11.8-5.5 12.8-3.8-3 6.1-9 9.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.6,348.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6 3.8-11.8 5.5-12.8 3.8-1.1-1.7 3-6.1 9-9.9s11.8-5.5 12.8-3.8-3 6.1-9 9.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.3,344.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.9-1.6-12.2-4.4-11.7-6.4 0.4-1.9 6.4-2.2 13.3-0.6s12.2 4.4 11.7 6.4c-0.4 1.9-6.4 2.2-13.3 0.6",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.2,339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.9-1.6-12.2-4.4-11.7-6.4 0.4-1.9 6.4-2.2 13.3-0.6s12.2 4.4 11.7 6.4c-0.4 1.8-6.4 2.1-13.3 0.6",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.5,338.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.9-0.4-2.2-6.4-0.6-13.3s4.4-12.2 6.4-11.7c1.9 0.4 2.2 6.4 0.6 13.3s-4.4 12.1-6.4 11.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.8,363.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.9-0.4-2.2-6.4-0.6-13.3s4.4-12.2 6.4-11.7c1.9 0.4 2.2 6.4 0.6 13.3s-4.5 12.1-6.4 11.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.2,341.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.5-2.4-0.8-5.6 1.6-7.1s5.6-0.8 7.1 1.6 0.8 5.6-1.6 7.1-5.6 0.8-7.1-1.6",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,362.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.1-1.2c0.2-0.3 16.6-34.9 21.3-68.5 7-50.4 6.5-66.1 6.4-66.2l2.4-0.4c0.1 0.6 0.7 16.1-6.4 67-4.7 34.1-21.4 68.9-21.6 69.3",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(322,320.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.4 0.5-10.3-3.7-10.3-3.7s4-5 9.4-5.5 10.3 3.7 10.3 3.7-4 5-9.4 5.5",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.7,385.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.3 0.3-5-6-6.1-14-1.1-8.1-0.1-14.8 2.1-15.1 2.3-0.3 5 6 6.1 14 1.2 8 0.2 14.8-2.1 15.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.3 0.3-5-6-6.1-14-1.1-8.1-0.1-14.8 2.1-15.1 2.3-0.3 5 6 6.1 14s0.2 14.8-2.1 15.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(331,358.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-8.1 1.1-14.8 0.1-15.2-2.1-0.3-2.3 6-5 14-6.1 8.1-1.1 14.8-0.1 15.2 2.1 0.3 2.3-6 5-14 6.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.8,362.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-8.1 1.1-14.8 0.1-15.2-2.1-0.3-2.3 6-5 14.1-6.1s14.8-0.1 15.2 2.1c0.2 2.3-6.1 5-14.1 6.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325,368.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.5-4.9-10.6-10.4-9.2-12.2s7.7 0.7 14.2 5.6 10.6 10.4 9.2 12.2c-1.3 1.9-7.7-0.7-14.2-5.6",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.6,350.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.5-4.9-10.6-10.4-9.2-12.2s7.8 0.7 14.2 5.6c6.5 4.9 10.6 10.4 9.2 12.2s-7.7-0.7-14.2-5.6",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.8-1.4 0.7-7.7 5.6-14.2s10.4-10.6 12.2-9.2-0.7 7.7-5.6 14.2-10.4 10.6-12.2 9.2",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.9,379.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.8-1.4 0.7-7.7 5.6-14.2s10.4-10.6 12.2-9.2-0.7 7.7-5.7 14.2c-4.8 6.5-10.2 10.6-12.1 9.2",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.1,384.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.2-0.6-2.3-7.4-0.1-15.3 2.1-7.8 5.6-13.7 7.9-13.1 2.2 0.6 2.3 7.4 0.1 15.3-2.2 7.8-5.7 13.7-7.9 13.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.2-0.6-2.3-7.4-0.1-15.3 2.1-7.8 5.6-13.7 7.8-13.1s2.3 7.4 0.1 15.3c-2.1 7.8-5.6 13.7-7.8 13.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.9,364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.9-2.1-13.7-5.6-13.1-7.8s7.4-2.3 15.3-0.1c7.9 2.1 13.7 5.6 13.1 7.8s-7.4 2.3-15.3 0.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.5,356.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.9-2.1-13.7-5.6-13.1-7.8s7.4-2.3 15.3-0.1c7.9 2.1 13.7 5.6 13.1 7.8s-7.4 2.3-15.3 0.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.5,371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4-7.1-5.7-13.7-3.7-14.8s6.9 3.7 10.9 10.7 5.7 13.7 3.7 14.8-6.8-3.6-10.9-10.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.9,345.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4-7.1-5.7-13.7-3.7-14.8s6.9 3.7 10.9 10.7c4 7.1 5.7 13.7 3.7 14.8s-6.9-3.7-10.9-10.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.6,352.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.1 4-13.7 5.7-14.8 3.7s3.7-6.9 10.7-10.9c7.1-4 13.7-5.7 14.8-3.7s-3.6 6.8-10.7 10.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.1,367.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.1 4-13.7 5.7-14.8 3.7s3.7-6.9 10.7-10.9c7.1-4 13.7-5.7 14.8-3.7s-3.7 6.9-10.7 10.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.3,361.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.2-0.9-5-4.1-4.2-7.3 0.9-3.2 4.1-5 7.3-4.2 3.2 0.9 5 4.1 4.2 7.3-0.9 3.2-4.2 5.1-7.3 4.2",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.57 240.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.8 119.11 2.789-0.253-10.801-119.11z",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.1,323.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s0.1-7.1 4.5-11.3c4.4-4.1 11.5-3.7 11.5-3.7s-0.1 7.1-4.5 11.3c-4.3 4.1-11.5 3.7-11.5 3.7",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.4,300.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.6-4-4.9-11.1-4.9-11.1s7.1-0.7 11.7 3.3 4.9 11.1 4.9 11.1-7.1 0.7-11.7-3.3",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.5,368.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-14.9-8.3 3.4-10.7 16.9 2c5.7 0.7 9.4 6.4 7.6 11.8-1.6 5.5-7.9 8-13 5.2",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.8,358.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.7-0.7-9.4-6.4-7.6-11.8 1.8-5.5 8.1-7.9 13.1-5.2l14.9 8.3-3.4 10.7z",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.7,356.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.7-3.4 2-16.9c0.7-5.7 6.4-9.4 11.8-7.6 5.5 1.8 7.9 8.1 5.2 13.1z",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.9,381.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.5-1.8-7.9-8.1-5.2-13.1l8.3-14.9 10.7 3.4-2 16.9c-0.6 5.8-6.3 9.5-11.8 7.7",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184,379.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.1 2.6-11.3-0.1-12.9-5.6l-4.7-16.4 10-5.1 10.6 13.3c3.5 4.6 2.1 11.2-3 13.8",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.8,344.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.6-4.5-2.1-11.1 3-13.7s11.3 0.1 12.9 5.6l4.7 16.4-10 5.1z",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.3,355.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.3 4.6-5.1-10 13.3-10.6c4.5-3.6 11.1-2.1 13.7 3 2.6 5.2-0.1 11.4-5.6 13",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.9,367.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.6-5.1 0.1-11.3 5.6-12.9l16.4-4.7 5.1 10-13.3 10.6c-4.6 3.5-11.2 2.1-13.8-3",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.5,363.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.5 2.3-9.9 0.5-12.2-3.9-2.3-4.5-0.5-9.9 3.9-12.2 4.5-2.3 9.9-0.5 12.2 3.9 2.4 4.5 0.6 9.9-3.9 12.2",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.1,345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0.3-11.2-23.4-12.4-51.7-2.6-28.2 2.9-45.5-10-60.3 8-0.7 16.1-1.5 24.1-2.2 12 14.9 0.5 32.8-2.8 61.5-4.5 28.8-2.2 53 1.1 52.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.8,333.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.3-0.3 1.2-24.5-8.6-52-8.3-27.7-22.9-43.2-13.8-60 8-0.7 16.1-1.5 24.1-2.2-10 16.9-1.5 33 1.1 61.1 4 28.1 0.5 52.8-2.8 53.1",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.3,342.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0.3-11.2-23.4-12.4-51.7-2.6-28.2 2.9-45.5-10-60.3 8-0.7 16.1-1.5 24.1-2.2 12 14.9 0.4 32.8-2.8 61.5-4.6 28.8-2.3 53 1.1 52.7",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.6,332.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.4 0.2-8.2-17.2-9.1-37.9-1.9-20.7 2.3-32.1-7.2-43 5.9-0.5 11.8-1.1 17.7-1.6 8.8 10.9 0.2 22.8-2.1 43.8-3.4 21.1-1.7 38.9 0.7 38.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.7,347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0-8.9-24.4-7.3-52.7 0.1-28.3 7.3-45-4.1-61 8.1 0.1 16.2 0.1 24.2 0.2 10.5 16-2.7 32.7-8.7 60.9-7.4 28.3-7.5 52.6-4.1 52.6",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.4,230.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24.1-2.2c2 31.8-28.1 126.9-28.1 126.9s7.8-93.1 4-124.7",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.4,226.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24.1-2.2c2 31.8 1.2 124.2 1.2 124.2s-21.5-90.3-25.3-122",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.7,244.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 19.8-1.8c1.6 26-3.1 71.1-3.1 71.1s-13.6-43.4-16.7-69.3",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.9,228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.2,242.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.1 50.2 21.2 89.3 21.2 89.3s-35.8-37.5-41.8-87.5z",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.8,244.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.3,232.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.2,330.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.7-0.2 1-20.1-7-42.6-6.8-22.6-18.8-35.3-11.3-49.1l19.8-1.8c-8.2 13.8-1.2 27 0.9 50 3.2 23 0.4 43.2-2.4 43.5",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7,337.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.7 0.2-9.2-19.1-10.1-42.3-2.1-23.1 2.4-37.3-8.2-49.4l19.8-1.8c9.8 12.2 0.4 26.8-2.3 50.3-3.8 23.7-1.9 43.5 0.8 43.2",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1,341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.7 0.3-9.1-19.1-10.1-42.3-2.1-23.1 2.4-37.3-8.2-49.4l19.8-1.8c9.8 12.2 0.4 26.8-2.3 50.3-3.8 23.6-1.9 43.4 0.8 43.2",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.2,240.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.6 26 21.6 99.8 21.6 99.8s-38.2-72.1-41.3-98z",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.9,246.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 19.8-1.8c1.6 26-23 103.9-23 103.9s6.3-76.2 3.2-102.1",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.9,243.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.9-1.5c2.6 41.1-20.7 76.6-20.7 76.6s8.7-34.2 3.8-75.1",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.8,247.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.9-1.5c2.6 41.1-20.7 76.6-20.7 76.6s8.7-34.2 3.8-75.1",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.2,224.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2 31.8 26.3 121.9 26.3 121.9s-46.7-88.1-50.5-119.7z",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.8,248.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-997.4 98.1-3191.2-2.1-4148.9-272-93.2-130.7 425.9 11.9 560.6-85 134.7-96.8 1014.7 37.9 1185.3 16.4 510.1-64.2 394.1-57.1 909.1-46 234.3 5.1 100.6-91.4 330.7-50.7 47.1 8.3 94.8-10.4 139.7-28.3h158.7c114.2 95.4 968.4 38.5 1088.2 115.1 117.6 75.5 193 256.8-223.4 350.5",
    fill: "#33ac6d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.1,757.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.3 1.8-15.6-1.9-19-8.6 0.3 5.4-3.6 10.7-8.8 12s-11.2-1.5-13.5-6.3c-4.5 15.2-20.4 26-36.2 24.8-15.8-1.3-29.8-14.5-31.8-30.2-1.3 6.4-7.2 11.7-13.8 12.1s-13.1-4-15.2-10.2c-2.1 12.9-14.1 23.5-27.2 23.9s-25.8-9.5-28.5-22.3c-2.6 17.4-20.5 31-38 28.9s-31.6-19.6-29.9-37.2c-1.8 8.4-13.3 12.8-20.2 7.8-7-5-6.4-17.3 0.9-21.6l-115.3-15.6h518.1l-108.9 26c0.1 7.4-5.4 14.7-12.7 16.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.5,775.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-60.9 0-110.7-49.8-110.7-110.7v-108.2c0-60.9 49.8-110.7 110.7-110.7s110.7 49.8 110.7 110.7v108.2c0 60.9-49.8 110.7-110.7 110.7",
    fill: "#7fb728"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.6,775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c41.2-16.2 70.5-56.3 70.5-103.1v-108.2c0-64.9-56.4-116.7-121.8-110.1 71.9-28.2 150.9 25.2 150.9 103.1v108.1c0 57.2-43.9 104.6-99.6 110.2",
    fill: "#478a33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.1,714.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1 0-2.4 1.9-3.4 1.7-1 0.3-1.8-1.7-2.9-1.7-17 0-12.6-29.4 0-29.4 1.1 0 2.2-2.4 3.2-1.9 1-0.4 2.1 1.9 3.2 1.9 12.5 0 16.9 29.4-0.1 29.4",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.1,714.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1 0-2.4 1.9-3.4 1.7-0.6 0.2-1.1-0.4-1.7-1 0.5-0.4 1-0.7 1.4-0.7 17 0 12.6-29.4 0-29.4-0.5 0-0.9-0.4-1.3-0.8 0.6-0.6 1.2-1.4 1.8-1.1 1-0.4 2.1 1.9 3.2 1.9 12.6 0 17 29.4 0 29.4",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.4,718.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8-0.5-1.6-0.6-2.5-0.1-0.5 0.3-1 0.8-1.1s1 0.3 1.1 0.8c0.1 0.8 0.3 1.5 0.5 2.2 0.2 0.5-0.1 1.1-0.6 1.2-0.4 0.2-1-0.1-1.2-0.6",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.3,724.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 2.2,-5.6 8.1,-8.9 14.1,-7.9 11.8,-2.3 6,1 0,0",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.3,621.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 0-2.2 1.8-3.2 1.6-0.9 0.3-1.7-1.6-2.7-1.6-15.8 0-11.7-27.3 0-27.3 1 0 2-2.2 2.9-1.8 0.9-0.4 1.9 1.8 2.9 1.8 11.8 0.1 15.8 27.3 0.1 27.3",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.3,621.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 0-2.2 1.8-3.2 1.6-0.6 0.1-1-0.4-1.6-0.9 0.5-0.3 0.9-0.6 1.3-0.6 15.8 0 11.7-27.3 0-27.3-0.4 0-0.8-0.4-1.2-0.8 0.6-0.6 1.2-1.3 1.7-1 0.9-0.4 1.9 1.8 2.9 1.8 11.8 0 15.8 27.2 0.1 27.2",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.9,624.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8-0.4-1.5-0.5-2.3-0.1-0.5 0.3-1 0.8-1 0.5-0.1 1 0.3 1 0.8 0.1 0.7 0.2 1.4 0.5 2 0.2 0.5-0.1 1-0.6 1.2-0.5 0-1-0.3-1.2-0.7",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.7,630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.1-5.2 7.5-8.3 13-7.3-2 5.2-7.4 8.2-13 7.3",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.8,650.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.9 0-2 1.6-2.8 1.4-0.8 0.2-1.5-1.4-2.4-1.4-14 0-10.4-24.2 0-24.2 0.9 0 1.8-2 2.6-1.6 0.8-0.4 1.7 1.6 2.6 1.6 10.4 0 14 24.2 0 24.2",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.8,650.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.9 0-2 1.6-2.8 1.4-0.5 0.1-0.9-0.4-1.4-0.8 0.4-0.3 0.8-0.6 1.2-0.6 14 0 10.4-24.2 0-24.2-0.4 0-0.7-0.3-1.1-0.7 0.5-0.5 1-1.1 1.5-0.9 0.8-0.4 1.7 1.6 2.6 1.6 10.4 0 14 24.2 0 24.2",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.8,654.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.7-0.4-1.4-0.5-2.1-0.1-0.4 0.3-0.8 0.7-0.9s0.8 0.3 0.9 0.7c0.1 0.6 0.2 1.2 0.4 1.8 0.1 0.4-0.1 0.9-0.5 1-0.4 0.2-0.8-0.1-1-0.5",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135,658.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.8-4.6 6.6-7.3 11.5-6.5-1.8 4.7-6.6 7.4-11.5 6.5",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.3,682.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2 0-2.6 2.1-3.6 1.8-1.1 0.3-1.9-1.8-3.1-1.8-18 0-13.4-31.2 0-31.2 1.2 0 2.3-2.5 3.4-2.1 1.1-0.5 2.2 2.1 3.4 2.1 13.3 0 17.9 31.2-0.1 31.2",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.3,682.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2 0-2.6 2.1-3.6 1.8-0.6 0.2-1.2-0.5-1.8-1 0.5-0.4 1-0.7 1.5-0.7 18 0 13.4-31.2 0-31.2-0.5 0-1-0.4-1.4-0.9 0.7-0.7 1.3-1.4 1.9-1.2 1.1-0.5 2.2 2.1 3.4 2.1 13.4-0.1 18 31.1 0 31.1",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.5,686.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.9-0.5-1.7-0.6-2.7-0.1-0.6 0.3-1.1 0.9-1.2s1.1 0.3 1.2 0.9c0.1 0.8 0.3 1.6 0.5 2.3 0.2 0.5-0.1 1.1-0.6 1.3-0.7 0.3-1.2 0-1.4-0.6",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.6,692.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.4-6 8.6-9.5 14.9-8.4-2.4 6-8.6 9.4-14.9 8.4",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.8,529.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2 0-2.7 2.1-3.8 1.8-1.1 0.3-2-1.8-3.2-1.8-18.7 0-13.9-32.3 0-32.3 1.2 0 2.4-2.6 3.5-2.1 1.1-0.5 2.3 2.1 3.5 2.1 13.9 0 18.7 32.3 0 32.3",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.8,529.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2 0-2.7 2.1-3.8 1.8-0.7 0.2-1.2-0.5-1.8-1.1 0.5-0.4 1.1-0.8 1.6-0.8 18.7 0 13.9-32.3 0-32.3-0.5 0-1-0.4-1.5-0.9 0.7-0.7 1.4-1.5 2-1.2 1.1-0.5 2.3 2.1 3.5 2.1 13.9 0.1 18.7 32.4 0 32.4",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.9,533.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.9-0.5-1.8-0.6-2.8-0.1-0.6 0.3-1.1 0.9-1.2s1.1 0.3 1.2 0.9c0.1 0.8 0.3 1.6 0.5 2.4 0.2 0.6-0.1 1.2-0.7 1.4-0.5 0.1-1.2-0.2-1.3-0.7",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.4,540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.5-6.2 8.9-9.8 15.4-8.7-2.4 6.2-8.8 9.8-15.4 8.7",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34,589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1 0-2.4 1.9-3.4 1.7-1 0.3-1.8-1.7-2.9-1.7-16.9 0-12.6-29.3 0-29.3 1.1 0 2.2-2.4 3.2-1.9 1-0.4 2.1 1.9 3.2 1.9 12.5 0 16.8 29.3-0.1 29.3",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34,589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1 0-2.4 1.9-3.4 1.7-0.6 0.2-1.1-0.4-1.7-1 0.5-0.4 1-0.7 1.4-0.7 16.9 0 12.6-29.3 0-29.3-0.5 0-0.9-0.4-1.3-0.8 0.6-0.6 1.2-1.3 1.8-1.1 1-0.4 2.1 1.9 3.2 1.9 12.6 0 16.9 29.3 0 29.3",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.4,592.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8-0.5-1.6-0.6-2.5-0.1-0.5 0.3-1 0.8-1.1s1 0.3 1.1 0.8c0.1 0.8 0.3 1.5 0.5 2.1 0.2 0.5-0.1 1.1-0.6 1.2-0.5 0.2-1 0-1.2-0.5",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.3,598.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.2-5.6 8.1-8.9 14-7.9-2.2 5.6-8 8.9-14 7.9",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.1,562.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.3 0-2.8 2.2-3.9 1.9-1.2 0.3-2.1-1.9-3.3-1.9-19.4 0-14.4-33.6 0-33.6 1.3 0 2.5-2.7 3.6-2.2 1.2-0.5 2.4 2.2 3.6 2.2 14.4 0 19.4 33.6 0 33.6",
    fill: "#ffe400"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142.1,562.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.3 0-2.8 2.2-3.9 1.9-0.7 0.2-1.3-0.5-1.9-1.1 0.6-0.4 1.1-0.8 1.6-0.8 19.5 0 14.4-33.6 0-33.6-0.5 0-1-0.5-1.5-1 0.7-0.7 1.4-1.5 2.1-1.3 1.2-0.5 2.4 2.2 3.6 2.2 14.4 0.1 19.4 33.7 0 33.7",
    fill: "#fdda00"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.9,566.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.9-0.5-1.9-0.7-2.9-0.1-0.6 0.4-1.2 1-1.3s1.2 0.3 1.3 1c0.1 0.9 0.3 1.7 0.6 2.5 0.2 0.6-0.1 1.2-0.7 1.4s-1.3-0.1-1.5-0.7",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.9,573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.5-6.4 9.2-10.2 16.1-9-2.6 6.4-9.2 10.2-16.1 9",
    fill: "#67a82f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.3,425.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 46.1-8.1 97.2-12.4 164.2-0.3-64.4 1-115.7 1.1-163.1-19.9 6.5-47.9 39.9-52.8 87-0.4 2.4-0.4 3.9-0.9 9.4 0.8-64.2 33.2-99 53.7-105.2v-8.7c-0.1-0.2-0.3-0.4-0.4-0.6 0.2-0.1 0.3-0.2 0.4-0.3-0.3-57.4-3.1-113.9-13.4-179.9 9.1-1.2 15.6 1.2 24.7 0 6.2 71.5 5 124.6 0.9 185 19.3 32.3 28 64.7 32.2 101.5-6.1-32.5-15.5-61.5-33.1-89.3",
    fill: "#925223"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(247.8,505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 142.1 115.2 257.2 257.2 257.2 142.1 0 257.2-115.2 257.2-257.2s-115.1-257.2-257.2-257.2-257.2 115.1-257.2 257.2",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361.2,365.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c35.5-31.3 98.2-54 149.4-54 44 0 84.1 14.8 112.9 41.7 25.3 23.6 40.5 55.5 40.5 85.4 0 81.4-69.7 97.5-131.1 111.8-48 11.2-93.4 21.7-93.4 63.1 0 20.3 17.6 42.1 56.4 42.1 28.7 0 57.1-7.1 84.4-21.2 21.6-11.1 42.2-26.5 60.1-44.9v57.6c-40.8 31.3-90.3 47.9-143.2 47.9-34.4 0-68.8-10.8-94.4-29.6-20.4-15-44.7-41.9-44.7-85.4 0-80.8 69.6-99.2 131-115.5 23.5-6.2 45.8-12.1 62.2-21.1 18.7-10.2 27.7-23.6 27.7-41 0-11.6-7.4-23.3-20.4-32-13.1-8.8-30.2-13.7-48.1-13.7-29 0-59.2 8.4-87.3 24.2-24.2 13.6-46 32.6-62.1 53.8zm143.8-112.6c-67.3 0-130.5 26.2-178.1 73.8-47.5 47.6-73.7 110.8-73.7 178 0 67.3 26.2 130.5 73.8 178s110.8 73.8 178 73.8 130.5-26.2 178-73.8 73.8-110.8 73.8-178-26.2-130.5-73.8-178-110.7-73.8-178-73.8",
    fill: "#4c9046",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(510.6,354.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c18.4 0 35.9 5 49.4 14.1 13.6 9.2 21.4 21.5 21.4 34 0 18.3-9.5 32.5-29 43.1-16.7 9.1-39 15-62.7 21.3-31.1 8.2-63.2 16.8-88.1 33.4-13.2 8.9-22.9 19-29.7 31.2-7.7 13.8-11.5 29.7-11.5 48.6 0 42.5 23.8 68.9 43.7 83.5 25.3 18.5 59.2 29.1 93 29.1 51.9 0 100.5-16.1 140.8-46.7v-50.6c-17.1 16.7-36.5 30.9-56.6 41.2-27.7 14.2-56.4 21.5-85.5 21.5-17.4 0-32.2-4.4-42.9-12.9-10.3-8.1-15.9-19.3-15.9-31.6 0-43.3 46.3-54.1 95.3-65.4 31.2-7.3 63.5-14.8 88.3-30.6 13.2-8.4 22.8-18.3 29.6-30.3 7.7-13.6 11.4-29.5 11.4-48.6 0-14.2-3.5-29.2-10.2-43.5-6.8-14.7-17.1-28.6-29.6-40.2-13.5-12.6-29.5-22.5-47.5-29.5-19.6-7.6-41.1-11.5-63.9-11.5-50.3 0-111.7 22.1-147 52.7v61.3c15.8-19.4 35.8-36.2 58.6-49 28.6-16.1 59.2-24.6 88.6-24.6m-5.6 404.5c-34.3 0-67.6-6.7-99-20-30.3-12.8-57.5-31.1-80.8-54.5-23.3-23.3-41.7-50.5-54.5-80.8-13.2-31.3-20-64.6-20-98.9s6.7-67.6 20-98.9c12.8-30.3 31.1-57.5 54.5-80.8 23.3-23.3 50.5-41.7 80.8-54.5 31.3-13.3 64.6-20 98.9-20s67.6 6.7 98.9 20c30.3 12.8 57.5 31.1 80.8 54.5 23.3 23.3 41.7 50.5 54.5 80.8 13.3 31.3 20 64.6 20 98.9s-6.7 67.6-20 98.9c-12.8 30.3-31.1 57.5-54.5 80.8-23.3 23.3-50.5 41.7-80.8 54.5-31.2 13.3-64.5 20-98.8 20m5.6-399.8c-59.8 0-119.2 36.2-151.8 83v-77.7c34.4-30.8 97.3-55.3 151.8-55.3 97.8 0 155.8 69.6 155.8 129.5 0 148.2-224.6 84.8-224.6 175 0 21.4 19.6 39.7 54 39.7 60.7 0 112.5-32.6 146.9-69.6v64.7c-39.7 30.8-89.7 49.1-145.5 49.1-67 0-141.5-41.1-141.5-117.4 0-145.5 221-93.3 221-177.7 0-22.3-29.5-43.3-66.1-43.3m-5.6 395c137.7 0 249.4-111.7 249.4-249.4 0-137.8-111.7-249.4-249.4-249.4-137.8 0-249.4 111.7-249.4 249.4 0 137.8 111.6 249.4 249.4 249.4",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.4,254.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.7 0 1.3-0.1 2-0.1 1.4 30 11.2 58.9 28.4 83.5-0.5 0.4-1.1 0.8-1.6 1.2-17.4-25-27.4-54.3-28.8-84.6",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79,348.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.8-4.1-9.6-8.7-8.5-10.3s6.8 0.3 12.6 4.4 9.6 8.7 8.5 10.3c-1.1 1.7-6.8-0.3-12.6-4.4",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.9,333.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.8-4.1-9.6-8.7-8.5-10.3s6.8 0.3 12.6 4.4 9.6 8.7 8.5 10.3-6.7-0.3-12.6-4.4",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.5,338.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.6-1.1 0.3-6.8 4.4-12.6s8.7-9.6 10.3-8.5-0.3 6.8-4.4 12.6c-4 5.9-8.6 9.6-10.3 8.5",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.8,359.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.6-1.1 0.4-6.8 4.4-12.6 4.1-5.8 8.7-9.6 10.3-8.5s-0.4 6.8-4.4 12.6c-4.1 5.8-8.7 9.6-10.3 8.5",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.8,339.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7 1.2-12.9 0.6-13.3-1.3-0.3-2 5-4.6 12-5.8s12.9-0.6 13.3 1.3c0.4 2-5 4.6-12 5.8",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.5,344.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7 1.2-12.9 0.6-13.3-1.3-0.3-2 5-4.6 12-5.8s12.9-0.6 13.3 1.3c0.4 2-5 4.6-12 5.8",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.8,326.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2-7-0.6-12.9 1.3-13.3 2-0.3 4.6 5 5.8 12s0.6 12.9-1.3 13.3c-2 0.3-4.6-5-5.8-12",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.2,351.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2-7-0.6-12.9 1.3-13.3 2-0.3 4.6 5 5.8 12s0.6 12.9-1.3 13.3-4.6-5-5.8-12",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.3,351.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.8-6-5.5-11.8-3.8-12.8 1.7-1.1 6.1 3 9.9 9s5.5 11.8 3.8 12.8-6.1-3-9.9-9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.6,329.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.8-6-5.5-11.8-3.8-12.8 1.7-1.1 6.1 3 9.9 9s5.5 11.8 3.8 12.8c-1.7 1.1-6.1-3-9.9-9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.4,334.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6 3.8-11.8 5.5-12.8 3.8-1.1-1.7 3-6.1 9-9.9s11.8-5.5 12.8-3.8-3 6.1-9 9.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.6,348.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6 3.8-11.8 5.5-12.8 3.8-1.1-1.7 3-6.1 9-9.9s11.8-5.5 12.8-3.8-3 6.1-9 9.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.3,344.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.9-1.6-12.2-4.4-11.7-6.4 0.4-1.9 6.4-2.2 13.3-0.6s12.2 4.4 11.7 6.4c-0.4 1.9-6.4 2.2-13.3 0.6",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.2,339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.9-1.6-12.2-4.4-11.7-6.4 0.4-1.9 6.4-2.2 13.3-0.6s12.2 4.4 11.7 6.4c-0.4 1.8-6.4 2.1-13.3 0.6",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.5,338.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.9-0.4-2.2-6.4-0.6-13.3s4.4-12.2 6.4-11.7c1.9 0.4 2.2 6.4 0.6 13.3s-4.4 12.1-6.4 11.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.8,363.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.9-0.4-2.2-6.4-0.6-13.3s4.4-12.2 6.4-11.7c1.9 0.4 2.2 6.4 0.6 13.3s-4.5 12.1-6.4 11.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.2,341.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.5-2.4-0.8-5.6 1.6-7.1s5.6-0.8 7.1 1.6 0.8 5.6-1.6 7.1-5.6 0.8-7.1-1.6",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,362.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.1-1.2c0.2-0.3 16.6-34.9 21.3-68.5 7-50.4 6.5-66.1 6.4-66.2l2.4-0.4c0.1 0.6 0.7 16.1-6.4 67-4.7 34.1-21.4 68.9-21.6 69.3",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(322,320.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.4 0.5-10.3-3.7-10.3-3.7s4-5 9.4-5.5 10.3 3.7 10.3 3.7-4 5-9.4 5.5",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.7,385.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.3 0.3-5-6-6.1-14-1.1-8.1-0.1-14.8 2.1-15.1 2.3-0.3 5 6 6.1 14 1.2 8 0.2 14.8-2.1 15.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.3 0.3-5-6-6.1-14-1.1-8.1-0.1-14.8 2.1-15.1 2.3-0.3 5 6 6.1 14s0.2 14.8-2.1 15.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(331,358.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-8.1 1.1-14.8 0.1-15.2-2.1-0.3-2.3 6-5 14-6.1 8.1-1.1 14.8-0.1 15.2 2.1 0.3 2.3-6 5-14 6.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.8,362.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-8.1 1.1-14.8 0.1-15.2-2.1-0.3-2.3 6-5 14.1-6.1s14.8-0.1 15.2 2.1c0.2 2.3-6.1 5-14.1 6.1",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(325,368.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.5-4.9-10.6-10.4-9.2-12.2s7.7 0.7 14.2 5.6 10.6 10.4 9.2 12.2c-1.3 1.9-7.7-0.7-14.2-5.6",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.6,350.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-6.5-4.9-10.6-10.4-9.2-12.2s7.8 0.7 14.2 5.6c6.5 4.9 10.6 10.4 9.2 12.2s-7.7-0.7-14.2-5.6",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.8-1.4 0.7-7.7 5.6-14.2s10.4-10.6 12.2-9.2-0.7 7.7-5.6 14.2-10.4 10.6-12.2 9.2",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(297.9,379.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.8-1.4 0.7-7.7 5.6-14.2s10.4-10.6 12.2-9.2-0.7 7.7-5.7 14.2c-4.8 6.5-10.2 10.6-12.1 9.2",
    fill: "#e3e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.1,384.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.2-0.6-2.3-7.4-0.1-15.3 2.1-7.8 5.6-13.7 7.9-13.1 2.2 0.6 2.3 7.4 0.1 15.3-2.2 7.8-5.7 13.7-7.9 13.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.8,356.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.2-0.6-2.3-7.4-0.1-15.3 2.1-7.8 5.6-13.7 7.8-13.1s2.3 7.4 0.1 15.3c-2.1 7.8-5.6 13.7-7.8 13.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.9,364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.9-2.1-13.7-5.6-13.1-7.8s7.4-2.3 15.3-0.1c7.9 2.1 13.7 5.6 13.1 7.8s-7.4 2.3-15.3 0.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.5,356.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.9-2.1-13.7-5.6-13.1-7.8s7.4-2.3 15.3-0.1c7.9 2.1 13.7 5.6 13.1 7.8s-7.4 2.3-15.3 0.1",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.5,371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4-7.1-5.7-13.7-3.7-14.8s6.9 3.7 10.9 10.7 5.7 13.7 3.7 14.8-6.8-3.6-10.9-10.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.9,345.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4-7.1-5.7-13.7-3.7-14.8s6.9 3.7 10.9 10.7c4 7.1 5.7 13.7 3.7 14.8s-6.9-3.7-10.9-10.7",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.6,352.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.1 4-13.7 5.7-14.8 3.7s3.7-6.9 10.7-10.9c7.1-4 13.7-5.7 14.8-3.7s-3.6 6.8-10.7 10.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.1,367.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-7.1 4-13.7 5.7-14.8 3.7s3.7-6.9 10.7-10.9c7.1-4 13.7-5.7 14.8-3.7s-3.7 6.9-10.7 10.9",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.3,361.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.2-0.9-5-4.1-4.2-7.3 0.9-3.2 4.1-5 7.3-4.2 3.2 0.9 5 4.1 4.2 7.3-0.9 3.2-4.2 5.1-7.3 4.2",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.57 240.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.8 119.11 2.789-0.253-10.801-119.11z",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(151.1,323.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s0.1-7.1 4.5-11.3c4.4-4.1 11.5-3.7 11.5-3.7s-0.1 7.1-4.5 11.3c-4.3 4.1-11.5 3.7-11.5 3.7",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.4,300.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.6-4-4.9-11.1-4.9-11.1s7.1-0.7 11.7 3.3 4.9 11.1 4.9 11.1-7.1 0.7-11.7-3.3",
    fill: "#217632"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184.5,368.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-14.9-8.3 3.4-10.7 16.9 2c5.7 0.7 9.4 6.4 7.6 11.8-1.6 5.5-7.9 8-13 5.2",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.8,358.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.7-0.7-9.4-6.4-7.6-11.8 1.8-5.5 8.1-7.9 13.1-5.2l14.9 8.3-3.4 10.7z",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.7,356.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.7-3.4 2-16.9c0.7-5.7 6.4-9.4 11.8-7.6 5.5 1.8 7.9 8.1 5.2 13.1z",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.9,381.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.5-1.8-7.9-8.1-5.2-13.1l8.3-14.9 10.7 3.4-2 16.9c-0.6 5.8-6.3 9.5-11.8 7.7",
    fill: "#ea5b2f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(184,379.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-5.1 2.6-11.3-0.1-12.9-5.6l-4.7-16.4 10-5.1 10.6 13.3c3.5 4.6 2.1 11.2-3 13.8",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.8,344.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.6-4.5-2.1-11.1 3-13.7s11.3 0.1 12.9 5.6l4.7 16.4-10 5.1z",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.3,355.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-16.3 4.6-5.1-10 13.3-10.6c4.5-3.6 11.1-2.1 13.7 3 2.6 5.2-0.1 11.4-5.6 13",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.9,367.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.6-5.1 0.1-11.3 5.6-12.9l16.4-4.7 5.1 10-13.3 10.6c-4.6 3.5-11.2 2.1-13.8-3",
    fill: "#ec6e45"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.5,363.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.5 2.3-9.9 0.5-12.2-3.9-2.3-4.5-0.5-9.9 3.9-12.2 4.5-2.3 9.9-0.5 12.2 3.9 2.4 4.5 0.6 9.9-3.9 12.2",
    fill: "#f9d535"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(268.1,345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0.3-11.2-23.4-12.4-51.7-2.6-28.2 2.9-45.5-10-60.3 8-0.7 16.1-1.5 24.1-2.2 12 14.9 0.5 32.8-2.8 61.5-4.5 28.8-2.2 53 1.1 52.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.8,333.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.3-0.3 1.2-24.5-8.6-52-8.3-27.7-22.9-43.2-13.8-60 8-0.7 16.1-1.5 24.1-2.2-10 16.9-1.5 33 1.1 61.1 4 28.1 0.5 52.8-2.8 53.1",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.3,342.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0.3-11.2-23.4-12.4-51.7-2.6-28.2 2.9-45.5-10-60.3 8-0.7 16.1-1.5 24.1-2.2 12 14.9 0.4 32.8-2.8 61.5-4.6 28.8-2.3 53 1.1 52.7",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.6,332.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.4 0.2-8.2-17.2-9.1-37.9-1.9-20.7 2.3-32.1-7.2-43 5.9-0.5 11.8-1.1 17.7-1.6 8.8 10.9 0.2 22.8-2.1 43.8-3.4 21.1-1.7 38.9 0.7 38.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.7,347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.3 0-8.9-24.4-7.3-52.7 0.1-28.3 7.3-45-4.1-61 8.1 0.1 16.2 0.1 24.2 0.2 10.5 16-2.7 32.7-8.7 60.9-7.4 28.3-7.5 52.6-4.1 52.6",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(270.4,230.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24.1-2.2c2 31.8-28.1 126.9-28.1 126.9s7.8-93.1 4-124.7",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.4,226.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24.1-2.2c2 31.8 1.2 124.2 1.2 124.2s-21.5-90.3-25.3-122",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.7,244.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 19.8-1.8c1.6 26-3.1 71.1-3.1 71.1s-13.6-43.4-16.7-69.3",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348.9,228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.2,242.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.1 50.2 21.2 89.3 21.2 89.3s-35.8-37.5-41.8-87.5z",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.8,244.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(301.3,232.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 20.6-1.9c3.1 50.2-25.3 93.6-25.3 93.6s10.7-41.7 4.7-91.7",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.2,330.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.7-0.2 1-20.1-7-42.6-6.8-22.6-18.8-35.3-11.3-49.1l19.8-1.8c-8.2 13.8-1.2 27 0.9 50 3.2 23 0.4 43.2-2.4 43.5",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.7,337.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.7 0.2-9.2-19.1-10.1-42.3-2.1-23.1 2.4-37.3-8.2-49.4l19.8-1.8c9.8 12.2 0.4 26.8-2.3 50.3-3.8 23.7-1.9 43.5 0.8 43.2",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1,341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.7 0.3-9.1-19.1-10.1-42.3-2.1-23.1 2.4-37.3-8.2-49.4l19.8-1.8c9.8 12.2 0.4 26.8-2.3 50.3-3.8 23.6-1.9 43.4 0.8 43.2",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.2,240.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1.6 26 21.6 99.8 21.6 99.8s-38.2-72.1-41.3-98z",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.9,246.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 19.8-1.8c1.6 26-23 103.9-23 103.9s6.3-76.2 3.2-102.1",
    fill: "#c4d451"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.9,243.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.9-1.5c2.6 41.1-20.7 76.6-20.7 76.6s8.7-34.2 3.8-75.1",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.8,247.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 16.9-1.5c2.6 41.1-20.7 76.6-20.7 76.6s8.7-34.2 3.8-75.1",
    fill: "#32a536"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(337.2,224.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2 31.8 26.3 121.9 26.3 121.9s-46.7-88.1-50.5-119.7z",
    fill: "#6ba62f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.8,248.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-997.4 98.1-3191.2-2.1-4148.9-272-93.2-130.7 425.9 11.9 560.6-85 134.7-96.8 1014.7 37.9 1185.3 16.4 510.1-64.2 394.1-57.1 909.1-46 234.3 5.1 100.6-91.4 330.7-50.7 47.1 8.3 94.8-10.4 139.7-28.3h158.7c114.2 95.4 968.4 38.5 1088.2 115.1 117.6 75.5 193 256.8-223.4 350.5",
    fill: "#33ac6d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.3,179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.8-5.9-11.7-14.1-11.7-14.1-2.9-2-3-6.4-0.1-8.5l18.5-13.6c2.7-2 6.5-1 7.9 2l2.1 4.4c0.5 1.2 0.6 2.5 0.3 3.7l-5.8 19.5c-1.2 3.3-5.9 18-11.2 6.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(383.3,179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.8-5.9-11.7-14.1-11.7-14.1-2.9-2-3-6.4-0.1-8.5l0.8-0.6c0 1.7 0.8 3.4 2.4 4.5 0 0 9.4 8.7 12.3 14.8 1.6 3.4 3.1 4.6 4.5 4.5-2.1 3.7-5.1 6.1-8.2-0.6",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.3,162.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9-1.6-0.1-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(375,166.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.2,171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6-0.1-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.5,175.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385.6,180.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6-0.1-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.3,162.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.1-3-1.8-5-5.1-10.4-2-3.2-2.8-3.3-3.8-4l7.6-5.6c2.7-2 6.5-1 7.9 2l2.1 4.4c0.5 1.2 0.6 2.5 0.3 3.7l-4.2 14.1c-1.9-0.8-3.1-1.7-4.8-4.2",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.3,162.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.1-3-1.8-5-5.1-10.4-2-3.2-2.8-3.3-3.8-4l7.6-5.6c2.7-2 6.5-1 7.9 2l2.1 4.4c0.5 1.2 0.6 2.5 0.3 3.7l-4.2 14.1c-1.9-0.8-3.1-1.7-4.8-4.2",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(393.4,160.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.7-0.4 4-12.4 4-12.4s-6.6 6.3-7.2 5.8 1.6-4 4.9-8.2c-4.3 2.9-7.1 3.9-7.5 3.4-0.5-0.7 2.5-3.3 7.5-7 1.1 0.5 2.1 1.4 2.6 2.6l2.1 4.4c0.1 0.1 0.1 0.3 0.2 0.4-2.9 5.6-5.9 11.4-6.6 11",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420.3,161.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18-9.5c-1.1-0.6-2-1.6-2.5-2.8l-1.7-4.5c-1.2-3.1 0.8-6.5 4.1-7l22.7-3.6c3.5-0.6 6.6 2.5 6 6.1 0 0-0.4 12.2 1.9 18.3 4.4 11.7-9.4 4.7-12.5 3",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(427.5,164.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c1-0.9 1.2-2.9-0.1-6.4-2.4-6.4-2-19.2-2-19.2 0.3-1.9-0.3-3.6-1.6-4.8l1-0.2c3.5-0.6 6.6 2.5 6 6.1 0 0-0.4 12.2 1.9 18.3 2.7 7-1.1 7.4-5.2 6.2",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.4,138.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.8,144.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(427.2,150.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6-0.1-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(428.3,156.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9c-0.7 0.3-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.6,162.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.3-0.8 0-1.6 0.8-1.9s1.6 0 1.9 0.8 0 1.6-0.8 1.9-1.6 0-1.9-0.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.3,151.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1-0.6-2-1.6-2.5-2.8l-1.7-4.5c-1.2-3.1 0.8-6.5 4.1-7l9.3-1.5c-0.2 1.2-0.7 1.9 0.2 5.6 1.5 6.2 3.2 7.3 3.9 11 0.6 2.9 0.4 4.4-0.3 6.2z",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.3,151.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1-0.6-2-1.6-2.5-2.8l-1.7-4.5c-1.2-3.1 0.8-6.5 4.1-7l9.3-1.5c-0.2 1.2-0.7 1.9 0.2 5.6 1.5 6.2 3.2 7.3 3.9 11 0.6 2.9 0.4 4.4-0.3 6.2z",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,149.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.1-0.1-0.1-0.3-0.2-0.4l-1.7-4.5c-0.5-1.2-0.4-2.5 0-3.7 6.1-1 10.1-1.3 10.2-0.5 0.1 0.7-2.5 2-7.6 3 5.3 0.5 9.3 1.5 9.3 2.2-0.1 0.8-9.2 1-9.2 1s11.9 5 11.6 5.8c-0.2 0.9-6.4-1-12.4-2.9",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.8,144.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-15.5 3.6c-4.1 1-7.9-1.9-7.5-5.8l1.8-17.5c0.4-3.8 4.8-6.3 8.6-4.9l14.6 5.2c2.5 0.9 4 3.1 3.7 5.6l-0.9 8.7c-0.3 2.4-2.2 4.4-4.8 5.1",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371.8,125.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.8 17.5c-0.2 2.2 0.9 4 2.7 5.1-3.9 0.5-7.3-2.3-6.9-5.9l1.8-17.5c0.4-3.8 4.8-6.3 8.6-4.9l1.2 0.4c-2.8 0.3-5.4 2.4-5.6 5.3",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.2,144.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.3,140.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.8,136.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.3,132.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.8,127.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.8 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.5,123.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.8 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.8,144.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.4 0.8c-2.8-2.4-4.7-6.1-5-10.3-0.3-4.8 1.5-9.1 4.6-11.9l5.8 2.1c2.5 0.9 4 3.1 3.7 5.6l-0.9 8.7c-0.3 2.3-2.2 4.3-4.8 5",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.8,139.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.8 1.5-7.1 2.3-7.3 1.8s2.7-2.2 6.6-3.7c0.1 0 0.2-0.1 0.4-0.1h-0.2c-4.7 0.7-8.5 0.7-8.6 0.1s3.6-1.7 8.3-2.4c0.5-0.1 0.9-0.1 1.4-0.2-0.1 0-0.3 0-0.4-0.1-4.7-0.8-8.3-2-8.2-2.6s4-0.5 8.6 0.3c0.1 0 0.2 0 0.3 0.1-0.1 0-0.2-0.1-0.2-0.1-3.3-2-5.8-4-5.5-4.4 0.3-0.5 3.2 0.8 6.5 2.8 0.4 0.2 0.7 0.5 1.1 0.7l-0.7 7.1c-0.8 0.2-1.5 0.4-2.1 0.7",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(417.9,129.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.5 8.5c-2.3 1.4-5.1 1.4-7-0.1l-6.8-5.5c-1.9-1.5-2.5-4.2-1.4-6.5l6.5-14c1.7-3.7 6.6-5.1 9.5-2.7l13.8 11c3.1 2.3 2.5 7.1-1.1 9.3",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.7,123.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.8-11c-2.2-1.8-5.5-1.5-7.7 0.4l0.6-1.2c1.7-3.7 6.6-5.1 9.5-2.7l13.8 11c2.8 2.3 2.5 6.7-0.6 9 0.4-2-0.1-4.1-1.8-5.5",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418,123.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.2,120.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.9,118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.8 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.6,115.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.9 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.9,112.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.3 0.2-0.8 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(401.4,110.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.2-0.4 0-0.9 0.4-1 0.4-0.2 0.9 0 1 0.4 0.2 0.4 0 0.9-0.4 1-0.4 0.2-0.8 0-1-0.4",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.4,137.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.8-5.5c-1.9-1.5-2.5-4.2-1.4-6.5l2.6-5.6c4.2-0.2 8.6 1.5 11.7 5.1 2.8 3.1 4.1 7.1 3.8 10.8l-2.9 1.8c-2.2 1.5-5.1 1.4-7-0.1",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(398.7,136.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.6 0.3-1.3 0.6-1.9 0.8l-5.6-4.5c0.1-0.4 0.2-0.8 0.3-1.3 0.9-3.8 2-6.7 2.6-6.6 0.5 0.1 0.2 3.3-0.7 7 0 0.1 0 0.2-0.1 0.3 0.1-0.1 0.1-0.2 0.2-0.2 2.7-3.9 5.3-6.7 5.8-6.4 0.5 0.4-1.2 3.8-3.9 7.7-0.1 0.1-0.2 0.2-0.2 0.3 0.4-0.3 0.7-0.6 1.1-0.9 3.8-2.9 7.1-4.8 7.5-4.2 0.4 0.5-2.4 3.2-6.1 6.1l-0.1 0.1c0.1-0.1 0.2-0.1 0.4-0.2 3.8-1.7 7-2.6 7.3-2.1 0 0.6-2.9 2.4-6.6 4.1",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403.4,157.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.4 1-5 0.1-5.9-1.9-0.5-1.3 0.8-2.6 0.6-3.9-0.3-1.8-3.2-2.8-4.3-5.3-0.9-2.2-0.5-4.5-0.9-6.1-0.8-2.5-3.7-5-5.3-8.7-2.9-6.9-3.4-13.3-1.1-14.3s6.5 3.9 9.4 10.8c1.6 3.7 1.3 7.6 2.5 9.9 0.8 1.5 2.8 2.8 3.7 5 1 2.5-0.2 5.3 0.8 6.8 0.8 1.1 2.7 1 3.2 2.3 0.9 1.9-0.3 4.4-2.7 5.4",
    fill: "#844b13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.7,173.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.2 0.9-3.4 0-3.8-1-0.4-1.1 0-2.7 1.2-3.2 0.7-0.3 1.2-0.3 1.7-0.1 0.8 0.3 1 1.1 1 1.1 0 0.1-0.1 0.3-0.2 0.3s-0.3 0-0.3-0.2c0 0-0.2-0.6-0.7-0.9-0.3-0.1-0.8-0.1-1.3 0.1-0.8 0.3-1.3 1.6-0.9 2.6 0.2 0.5 0.9 1.6 3.2 0.8 0.6-0.2 1.1-0.7 1.4-1.3 2-4.1-2.8-14.8-2.8-14.9-0.1-0.1 0-0.3 0.1-0.3 0.1-0.1 0.3 0 0.3 0.1 0.2 0.4 4.9 11 2.8 15.3-0.4 0.8-0.9 1.3-1.7 1.6",
    fill: "#844b13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(413,168.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.5-1.5-8.7-12.2-8.9-12.7 0-0.1 0-0.3 0.2-0.3 0.1-0.1 0.3 0 0.3 0.1s4.3 11 8.6 12.4c0.7 0.2 1.3 0.2 1.9-0.1 2.2-1 1.9-2.3 1.7-2.8-0.4-1-1.7-1.5-2.5-1.1-0.5 0.2-0.8 0.5-0.9 0.9-0.2 0.6 0.1 1.1 0.1 1.1 0.1 0.1 0 0.3-0.1 0.3s-0.3 0-0.4-0.1c0 0-0.4-0.7-0.1-1.5 0.2-0.5 0.6-0.9 1.2-1.2 1.2-0.5 2.6 0.3 3.1 1.3s0.2 2.4-2 3.4c-0.6 0.5-1.4 0.5-2.2 0.3",
    fill: "#844b13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.1,436.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 1.6-2.5 2.7-4.3 3.2l-28.1 8.2c-4.9 1.4-26.3 7.3-16.7-8.1 4.9-7.9 7.9-25.2 7.9-25.2 0.2-5.2 5.4-8.6 10.2-6.8l30.9 11.6c4.4 1.7 6.2 7 3.7 11z",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.6,441.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-2.8 4.5-3.1 7.3-1.9 8.9-6.2 0.5-11.4-1.2-5.7-10.3 4.9-7.9 7.9-25.2 7.9-25.2 0.2-5.2 5.4-8.6 10.2-6.8l1.4 0.5c-2.1 1.3-3.5 3.6-3.6 6.4 0 0.1-3.1 18.3-8.3 26.5",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(505.6,415.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.2-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503.5,423.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.1,432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-2 1.2-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(497.9,439.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.2-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(494.5,447.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.1,436.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 1.6-2.5 2.7-4.3 3.2l-20.2 5.9c-0.5-2.7-0.3-4.8 1.4-8.8 2-4.9 4.7-6 8.6-14.3 2.3-5 1.8-6 1.9-7.8l12.7 4.8c4.4 1.7 6.2 7 3.7 11z",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.1,436.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 1.6-2.5 2.7-4.3 3.2l-20.2 5.9c-0.5-2.7-0.3-4.8 1.4-8.8 2-4.9 4.7-6 8.6-14.3 2.3-5 1.8-6 1.9-7.8l12.7 4.8c4.4 1.7 6.2 7 3.7 11z",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(543.1,436.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-0.1 0.2-0.2 0.4-0.4 0.5-9 0.9-18.3 1.8-18.4 0.6s18.1-4.9 18.1-4.9-12.8-3-12.7-4.1c0.1-1 6-1.2 13.7-0.4-6.9-2.9-10.3-5.4-9.9-6.4 0.4-1.1 5.9 0.4 14.3 3.6 0.3 1.7 0 3.5-1 5.2z",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.4,467.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s-15 9.1-20.6 16.5c-10.8 14.6-13.1-7.5-13.6-12.6l-2.6-29.1c-0.2-1.8 0.4-3.7 1.5-5.2l4.2-5.6c2.8-3.8 8.5-4.1 11.6-0.5l22.1 24.5c3.4 3.8 2.1 9.9-2.6 12",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(578.4,467.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0s-15 9.1-20.6 16.5c-6.4 8.6-9.8 4.4-11.7-1.5 1.9 0.5 4.4-0.7 7.6-5 5.8-7.8 21.6-17.4 21.6-17.4 2.5-1.1 4.1-3.3 4.6-5.7l1 1.1c3.5 3.8 2.2 9.9-2.5 12",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576.6,463.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(570.1,468.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(562.9,474.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-2 1.2-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.8,479.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.6 1-1.9 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.1,485.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1-0.7-1.2-2-0.6-2.9 0.7-1 2-1.2 2.9-0.6 1 0.7 1.2 2 0.6 2.9-0.7 1.1-2 1.3-2.9 0.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.2,458.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.1 3-5 3.9-7.7 4.5l-1.9-21c-0.2-1.8 0.4-3.7 1.5-5.2l4.2-5.6c2.8-3.8 8.5-4.1 11.6-0.5l9 10c-1.7 0.7-2.8 0.6-6.6 4.6-6.2 6.6-6.3 9.5-10.1 13.2",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.2,458.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-3.1 3-5 3.9-7.7 4.5l-1.9-21c-0.2-1.8 0.4-3.7 1.5-5.2l4.2-5.6c2.8-3.8 8.5-4.1 11.6-0.5l9 10c-1.7 0.7-2.8 0.6-6.6 4.6-6.2 6.6-6.3 9.5-10.1 13.2",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.2,446.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1 0.5-8.5-10.3-8.5-10.3s3.2 18.3 2.1 18.6-3.7-8.7-6.1-17.3c0.1-0.2 0.2-0.4 0.4-0.5l4.2-5.6c1.1-1.5 2.7-2.5 4.4-2.8 6 6.6 9.4 11.2 8.5 12-0.8 0.7-4.4-1.5-9.6-6.9 3.6 6.7 5.6 12.3 4.6 12.8",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.9,416.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.2 5.7c-3.1 1.6-7.2 0.9-9.9-1.8l-16.5-15.9c-4.4-4.2-3.8-11 1.1-13.5l22.6-11.5c4.9-2.5 11.3 0.8 12.7 6.5l5.1 21.7c0.7 3.6-0.8 7.2-3.9 8.8",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.2,384.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-22.6 11.5c-2.8 1.4-4.2 4.3-4 7.2-3.7-4.2-2.9-10.5 1.7-12.9l22.6-11.5c4.9-2.5 11.3 0.8 12.7 6.5l0.4 1.9c-2.6-3.2-7.1-4.6-10.8-2.7",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(523.2,393.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.6-0.4-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(527.9,390.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.6-0.4-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.2,388.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.6-0.4-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(538.6,385.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.5-0.4-0.6-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.5,382.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.5-0.4-0.6-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.2,380.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.5-0.4-0.6-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.9,416.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.2 5.7c-3.1 1.6-7.2 0.9-9.9-1.8l-3.6-3.4c0.7-5.3 3.7-10.5 8.5-14.1 5.5-4.1 12.2-5.3 18-3.7l2 8.6c0.8 3.5-0.7 7.1-3.8 8.7",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.3,419.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-4.8-3.5-8.4-6.8-7.9-7.5s4.8 1.6 9.6 5.1c0.2 0.1 0.3 0.2 0.5 0.3l-0.2-0.2c-4.5-5.1-7.5-9.7-6.9-10.3 0.7-0.6 4.9 3 9.4 8.1 0.5 0.5 0.9 1 1.3 1.5-0.1-0.2-0.2-0.4-0.2-0.6-2.7-6.2-4.2-11.6-3.3-11.9 0.8-0.4 3.7 4.4 6.4 10.6 0.1 0.1 0.1 0.3 0.2 0.4v-0.4c-0.2-5.6 0.3-10.1 1-10.1 0.8 0 1.5 4.5 1.7 10v1.8l-9.2 4.7c-0.8-0.4-1.6-1-2.4-1.5",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(580.7,443.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-20.8-9.6c-3.5-1.6-5.7-5.1-5.3-8.6l1.2-12.5c0.3-3.5 3.1-6.2 6.8-6.8l22-3.1c5.8-0.8 11.2 3.9 10.7 9.4l-2.5 25.2c-0.4 5.6-6.6 8.6-12.1 6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(581.5,443.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c2.8-0.9 4.9-3.3 5.2-6.4l2.5-25.2c0.4-4.1-2.5-7.8-6.5-9l1.9-0.3c5.8-0.8 11.2 3.9 10.7 9.4l-2.5 25.2c-0.4 5.2-6 8.1-11.3 6.3",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.5,438.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.5-0.3-0.6-1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.5,433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3s0.6 1 0.3 1.6c-0.3 0.5-1 0.6-1.6 0.3s-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590,427.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3s-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590.5,421.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6s-1 0.6-1.6 0.3c-0.5-0.4-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(591,414.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.5-0.3-0.7-1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(591.3,408.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3-0.5 1-0.6 1.6-0.3 0.5 0.3 0.6 1 0.3 1.6-0.3 0.5-1 0.6-1.6 0.3-0.6-0.4-0.7-1.1-0.3-1.6",
    fill: "#f18d1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.4,435.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.5-2.1c-3.5-1.6-5.7-5.1-5.3-8.6l1.2-12.5c0.3-3.5 3.1-6.2 6.8-6.8l8.7-1.2c3.5 4.9 4.9 11.5 3.1 18.1-1.6 5.9-5.3 10.5-10 13.1",
    fill: "#f49d39"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(570.6,418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0 0.9-5.6 1.5-12.3 1.3h-0.6c0.6 0.2 1.3 0.4 1.9 0.7 6.4 2.3 11.3 4.9 11 5.8s-5.7-0.3-12.1-2.6c-0.1 0-0.1-0.1-0.2-0.1 0.2 0.1 0.3 0.2 0.5 0.3 5 3.2 8.7 6.4 8.2 7.1-0.4 0.7-4.8-1.4-9.8-4.6-0.9-0.6-1.7-1.1-2.4-1.7l1-10.2c0.6-0.2 1.1-0.4 1.7-0.6 5.2-1.8 9.7-2.8 9.9-2.1 0.3 0.7-3.8 2.8-9 4.6-0.1 0-0.3 0.1-0.4 0.1h0.4c6.8 0.1 12.3 1 12.2 2",
    fill: "#8b5a1f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.4,426.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.1 2.1-1.2 5.5-3.1 8.3-2.2 3.2-6.6 3.9-7.6 6.3-0.7 1.7 0.8 4-0.3 5.7-1.8 2.7-5.8 3.1-8.8 1-3.1-2.1-4.1-5.9-2.2-8.6 1.1-1.7 3.8-1 5.2-2.3 1.9-1.8 0.9-6.1 3.1-9.3 1.9-2.8 5.1-4.1 6.6-5.9 2.4-2.9 3.2-8.4 6.4-13.2 6.1-8.9 13.4-14.5 16.3-12.5 3 2 0.4 10.9-5.7 19.8-3.2 4.7-8.1 7.4-9.9 10.7",
    fill: "#844b13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(519,460.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c-1.2 0.1-2.3-0.1-3.2-0.8-2.8-2-2.7-4.1-1.8-5.4 1-1.4 3.3-2.1 4.8-1 0.8 0.6 1.3 1.3 1.4 2 0.2 1.2-0.6 2-0.6 2.1-0.1 0.1-0.4 0.1-0.5 0-0.2-0.1-0.2-0.4-0.1-0.5 0 0 0.6-0.7 0.5-1.5-0.1-0.5-0.5-1-1.1-1.5-1-0.7-2.9-0.3-3.8 0.9-0.5 0.6-1.3 2.4 1.6 4.4 0.8 0.6 1.6 0.8 2.6 0.7 6.5-0.7 15.7-14.9 15.7-15 0.1-0.2 0.3-0.2 0.5-0.1s0.2 0.3 0.1 0.5c-0.3 0.5-9.3 14.5-16.1 15.2",
    fill: "#844b13"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.7,467.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0.3 1 0.8 1.7 1.6 2.2 3 1.9 4.3 0.5 4.7-0.1 0.8-1.3 0.5-3.2-0.5-3.9-0.7-0.4-1.3-0.6-1.8-0.5-0.9 0.2-1.3 1-1.3 1-0.1 0.2-0.3 0.2-0.5 0.1s-0.3-0.3-0.2-0.5c0 0 0.5-1.1 1.7-1.3 0.7-0.1 1.5 0.1 2.4 0.6 1.6 1 1.7 3.4 0.8 4.8s-2.8 2.1-5.7 0.3c-1-0.6-1.6-1.5-1.9-2.7-1.8-6.6 7.9-20.1 8.3-20.7 0.1-0.1 0.3-0.2 0.5-0.1s0.2 0.3 0.1 0.5c0 0.3-9.9 14-8.2 20.3",
    fill: "#844b13"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainLifequalityW150);
export default __webpack_public_path__ + "static/media/train-lifequality-w150.aa87c96530ba7af3d0a0a2e8d1958c1f.svg";
export { ForwardRef as ReactComponent };